import { ref, reactive, computed, watch } from 'vue'
import { defineStore } from 'pinia';
import { useRequestsStore } from '@/stores/storeRequests';

export const useFieldsStore = defineStore('fields', () => {      

    const storeRequests = useRequestsStore()

    const fields = ref({
        lastName: {
            title: '',
            disabledBtn: false,
        },
        size: {
            title: '',
            disabledBtn: false,
        },
        fullName: {
            title: '',
            disabledBtn: false,
        },
        inn: {
            title: '',
            disabledBtn: false,
        },
        companyName: {
            title: '',
            disabledBtn: false,
        },
        legalAddress: {
            title: '',
            disabledBtn: false,
        },
        email: {
            title: '',
            disabledBtn: false,
        },
        phone: {
            title: '',
            disabledBtn: false,
        },
        city: {
            title: '',
            disabledBtn: false,
        },
        workplace: {
            title: '',
            disabledBtn: false,
        },
        code: {
            title: '',
            disabledBtn: false,
        },
        password: {
            title: '',
            disabledBtn: false,
        },
        passwordRepeat: {
            title: '',
            disabledBtn: false,
        },
        rules: {
            title: false,
            disabledBtn: false,
        },
        agreement: {
            title: false,
            disabledBtn: false,
        },
        agreeToAdvertising: {
            title: false,
            disabledBtn: false,
        },
        category: {
            title: '',
            id: '',
            path: '',
            disabledBtn: false,
        },
        select: {
            id: '',
            disabledBtn: false,
        },
        message: {
            title: '',
            disabledBtn: false,
        },
        telegram: {
            title: '',
            required: false,
            disabledBtn: false,
        },
        vk: {
            title: '',
            required: false,
            disabledBtn: false,
        },
        max: {
            title: '',
            required: false,
            disabledBtn: false,
        },
        files: [],
        filesForPost: [],
        
    });      
    
    const updateFields  = (fieldName, fieldKey, value) => {
        if(fields.value[fieldName]) {
            fields.value[fieldName][fieldKey] = value;
        } else {
            console.log('updateFields:', fields.value[fieldName], value);
        }          
    }
   
    const updateFiles = () => {
        fields.value.files = [];   
        fields.value.filesForPost = []; 
    } 

    const updateRegestrationBtn = () => {
        fields.value.firstName.disabledBtn = false 
        fields.value.city.disabledBtn = false 
        fields.value.position.disabledBtn = false 
        fields.value.workplace.disabledBtn = false 
        fields.value.telegram.disabledBtn = false 
        fields.value.vk.disabledBtn = false 
        fields.value.max.disabledBtn = false 
        fields.value.phone.disabledBtn = false 
        fields.value.email.disabledBtn = false
        fields.value.agreement.disabledBtn = false
        fields.value.rules.disabledBtn = false 
    }
    const updateFeedbackBtn = () => {
        fields.value.firstName.disabledBtn = false 
        fields.value.select.disabledBtn = false 
        fields.value.email.disabledBtn = false
        fields.value.message.disabledBtn = false
        fields.value.agreement.disabledBtn = false
        fields.value.files = []
        fields.value.filesForPost = []
    }
   
    const updateBtnsTitles = (arrayFields = []) => {
        arrayFields.forEach((field) => {
            fields.value[field].disabledBtn = false
            fields.value[field].title = ''
        })
    }

    const isBtnDisabled = (keys = []) => {
		return keys.some((key) => !fields.value[key]?.disabledBtn);
	};

    const pickupPoint = ref(null)

    return {
        updateFields,
        updateFiles,
        isBtnDisabled,
        updateRegestrationBtn,
        updateFeedbackBtn,
        updateBtnsTitles,

        fields,
        pickupPoint,
	}
})
